import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="-1 -1 20 20">
    <path d="M15.8 14.2V3.8c0-.8-.7-1.5-1.5-1.5H3.8c-.8 0-1.5.7-1.5 1.5v10.5c0 .8.7 1.5 1.5 1.5h10.5c.8 0 1.5-.7 1.5-1.6zm-9.4-4.1l1.9 2.3L10.9 9l3.4 4.5H3.8l2.6-3.4z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/spacetemplate-gallery.es6.js